import React from "react";
import sec from "../assets/imgTwo/sec.svg";
import  bg from "../assets/imgTwo/Vector.svg";
import "../App.css";
import Navbar from "../components/Navbar";
import OurCompliance from "../components/OurCompliance";
import Footer from "../components/Footer";


const HeroSection = () => {
  return (
    <section
      id="about"
      className=" bg-[#FFFFFF] md:px-[5em] py-16 animate-slidein"
    >
      <div className="container px-2 md:px-0 mx-auto flex flex-col-reverse justify-between md:flex-row items-center">
        <div className="w-full md:w-1/2 p-4">
          <h2 className="text-2xl md:text-[2.5rem] font-bold mb-4 leading-normal">
          Safeguarding your Data<br></br> and Securing Every<br></br> Transactions. </h2>
          <p className="text-gray-800 text-lg">
          At Uniswitch, we take the security and privacy of our customers very seriously. We understand the importance of safeguarding your data and ensuring a secure environment for your online activities. This page outlines our commitment to security and the measures we take to protect your information.
          </p>


        </div>
        <div className="w-full md:w-[35em] p-2 flex md:justify-end"
             style={{
              backgroundImage: `url(${bg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
        >
          <img src={sec} alt="sarepay" className="rounded-lg" />

        </div>
      </div>
    </section>
  );
};






export const Security = () => (
  <div className="font-san mx-auto bg-[#FFFFFF] pt-6">
    <Navbar />
    <HeroSection />
    <OurCompliance />
    <Footer />
  </div>
);

export default Security;
